import { useMiddleware } from "@/store/middleware";
import { AccountStatus } from "~/types/app";
import { isSpecialSubdomain } from "~/utils/helper";

export default defineNuxtRouteMiddleware(async (to, from) => {
  const auth = useAuth();

  const middleware = useMiddleware();
  const host = window.location.host;
  const subdomain = host.split(".")[0];
  const config = useRuntimeConfig();

  //  Check if user is logged in if not refetch user cookie
  if (!auth.isSuccess && !auth.isPending) {
    try {
      await auth.refetch();
    } catch (e) {
      console.log(e);
    }
  }

  // Authenticated users with a join_code are always sent to join-account, regardless of account count
  const rawJoinCode = to.query.join_code;
  const joinCode = Array.isArray(rawJoinCode) ? rawJoinCode[0] : rawJoinCode;
  if (auth.isSuccess && typeof joinCode === "string" && joinCode) {
    return navigateTo(
      { path: `${config.public.primaryURL}/onboarding/join-account`, query: { join_code: joinCode } },
      { external: true }
    );
  }

  const account = ref<{ account_status: string }>({ account_status: "" });
  if (!isSpecialSubdomain(subdomain)) {
    try {
      if (!middleware.account || middleware.accountDataIsStale) {
        await middleware.accountRefetch();
      }
      account.value = middleware.account;
    } catch (e) {
      if (auth.isSuccess) {
        return navigateTo(`${config.public.primaryURL}/switch`, {
          external: true,
        });
      } else {
        return;
      }
    }

    // Validate account status only on user accounts.
    if (auth?.model_type == 'users') {
      return checkStatus(account.value?.account_status);
    }
    return;
  } else {
    if (auth.isSuccess && auth.user?.accounts_count && auth.user?.active_account?.account_status == AccountStatus.ACTIVE.toUpperCase()) {
      return navigateTo(`${config.public.primaryURL}/switch`, {
        external: true,
      });
    } else {
      return;
    }
  }

  //if user is logged in return
  function checkStatus(status: string) {
    switch (status) {
      case "ONBOARDING":
        return navigateTo(`${config.public.primaryURL}/onboarding/account`, {
          external: true,
          replace: true,
        });
      case "ACTIVE":
        return navigateTo("/hub/sessions");
      case "PENDING":
        return navigateTo(`/system/pending`, {
          external: true,
        });
      case "CLOSED":
        return navigateTo(`/system/closed`, {
          external: true,
        });
      default:
        return navigateTo(`${config.public.primaryURL}/switch`, {
          external: true,
        });
    }
  }
});
